<div class="terms-glass-modal">
    <!-- Modal Body -->
    <div class="modal-body terms-body">
        <div class="terms-header d-flex align-items-center gap-3 mb-2 justify-content-center p-2">
            <div class="rounded-circle d-flex align-items-center justify-content-center shadow-sm flex-shrink-0"
                style="width: 40px; height: 40px; background: linear-gradient(135deg, #FF9933 0%, #FF512F 100%);">
                <i class="bi bi-file-earmark-text-fill text-white"></i>
            </div>
            <h2 class="modal-title divine-font fw-bold mb-0">Terms Of Service Agreement</h2>
        </div>

        <div class="terms-content">

            <h3>1. Introduction</h3>

            <h4>1.1 Contract</h4>
            <p>You agree that by clicking ("Sign Up"). or similar, registering, accessing or using our services
                (described
                below), you are agreeing to enter into a legally binding contract with Shivam CloudSoft Solutions LLP.
                If
                you
                do not agree to this contract ("Contract") or ("User Agreement"), do not click ("Sign Up") (or similar)
                and
                do
                not access or otherwise use any of our Services. If you wish to terminate this contract, at any time you
                can
                do
                so by closing your account and no longer accessing or using our Services.
            </p>

            <p> When you use our Services you agree to all of these terms. Your use of our Services is also subject to
                our
                Cookie Policy and our Privacy Policy, which covers how we collect, use, share, and store your personal
                information.
            </p>

            <p>Services</p>

            <p>This Contract applies to clouddimension.in and other websites hosted in Shivam CloudSoft Solutions LLP,
                apps,
                communications and other services that state that they are offered under this Contract ("Services"),
                including
                the offsite collection of data for those Services, such as our ads and the ("Signup using CloudDimension
                Technology Pvt Ltd") plugins. Registered users of our Services are ("Members") and unregistered users
                are
                ("Visitors").
            </p>

            <p>Shivam CloudSoft Solutions LLP</p>

            <p>You are entering into this Contract with Shivam CloudSoft Solutions LLP (also referred to as ("we") and
                ("us")).</p>

            <p>This Contract applies to Members and Visitors. As a Visitor or Member of our Services, the collection,
                use
                and
                sharing of your personal data is subject to Privacy Policy (which includes our Cookie Policy and other
                documents
                referenced in this Privacy Policy) and updates.</p>

            <h3>1.2 Members and Visitors</h3>
            <p>When you register and join the Shivam CloudSoft Solutions LLP Service you become a Member. If you have
                chosen
                not to register for our Services, you may access certain features as a ("Visitor")</p>

            <h3>1.3 Change</h3>
            <p>We may make changes to the Contract. We may modify this Contract, our Privacy Policy and our Cookies
                Policy
                from
                time to time. If we make material changes to it, we will provide you notice through our Services, or by
                other
                means, to provide you the opportunity to review the changes before they become effective. We agree that
                changes
                cannot be retroactive. If you object to any changes, you may close your account. Your continued use of
                our
                Services after we publish or send a notice about our changes to these terms means that you are
                consenting to
                the
                updated terms as of their effective date.</p>

            <h3>2. Obligations</h3>

            <h4>2.1 Service Eligibility</h4>
            <p>Here are some promises that you make to us in this Contract:</p>

            <p>You’re eligible to enter into this Contract and you are at least our ("Minimum Age."). The Services are
                not
                for
                use by anyone under the age of 18. To use the Services, you agree that: (1) you must be the ("Minimum
                Age")
                (described below) or older; (2) you will only have one Shivam CloudSoft Solutions LLP account, which
                must
                be
                in your real name; and (3) you are not already restricted by Shivam CloudSoft Solutions LLP from using
                the
                Services. Creating an account with false information is a violation of our terms, including accounts
                registered
                on behalf of others or persons under the age of 16. ("Minimum Age") means 16 years old. However, if law
                requires that you must be older in order for Shivam CloudSoft Solutions LLP to lawfully provide the
                Services
                to you without parental consent (including using of your personal data) then the Minimum Age is such
                older
                age.
            </p>

            <h3>2.2 Your Account</h3>
            <p>You will keep your password a secret.</p>

            <p>You will not share an account with anyone else and will follow our rules and the law. Members are account
                holders. You agree to: (1) use a strong password and keep it confidential; (2) not transfer any part of
                your
                account (e.g., connections) and (3) follow the law and our list of Dos and Don’ts and Professional
                Community
                Policies. You are responsible for anything that happens through your account unless you close it or
                report
                misuse. As between you and others (including your employer), your account belongs to you. However, if
                the
                Services were purchased by another party for you to use (e.g. Recruiter seat bought by your employer),
                the
                party paying for such Service has the right to control access to and get reports on your use of such
                paid
                Service; however, they do not have rights to your personal account.
            </p>

            <h4>2.3 Payment</h4>
            <p>You’ll honor your payment obligations and you are okay with us storing your payment information. You
                understand that there may be fees and taxes that are added to our prices. Refunds are subject to our
                policy.
                If you buy any of our paid Services (“Premium Services”), you agree to pay us the applicable fees and
                taxes
                specific to the paid Services. Failure to pay these fees will result in the termination of your paid
                Services. Also, you agree that:
                <br>• All of your purchases of Services are subject to Shivam CloudSoft Solutions LLP’s refund policy.
                <br>• We may calculate taxes payable by you based on the billing information that you provide us at the
                time
                of purchase.
                <br>You can get a copy of your invoice through your Shivam CloudSoft Solutions LLP account settings
                under
                User profile.
            </p>

            <h4>2.4 Notices and Messages</h4>
            <p>You are okay with us providing notices and messages to you through our websites, apps, and contact
                information. If your contact information is out of date, you may miss out on important notices. You
                agree
                that we will provide notices and messages to you in the following ways: (1) within the Service, or (2)
                sent
                to the contact information you provided us (e.g., email, mobile number, physical address). You agree to
                keep
                your contact information up to date.</p>

            <h3>3. Rights and Limits</h3>
            <h4>3.1 Your License to Shivam CloudSoft Solutions LLP.</h4>
            <p>You own all of the content, feedback and personal information you provide to us, but you also grant us a
                non-exclusive license to it. You and Shivam CloudSoft Solutions LLP agree that if content includes
                personal data, it is subject to our Privacy Policy.</p>

            <h4>3.2 Service Availability</h4>
            <p>We may change or end any Service or modify our prices prospectively. We may change, suspend or
                discontinue
                any of our Services. We may also modify our prices effective prospectively upon reasonable notice to the
                extent allowed under the law.</p>

            <h4>3.3 Other Content, Sites and Apps</h4>
            <p>Your use of other websites content and information posted on our Platform Others may offer their own
                products
                and services through their websites or app hosted on our platform, and we aren’t responsible for those
                activities.</p>

            <h4>3.4 Limits</h4>
            <p>Shivam CloudSoft Solutions LLP reserves the right to limit your use of the Services. CloudDimension
                Technology Pvt Ltd reserves the right to restrict, suspend, or terminate your account if you breach this
                Contract or the law or are misusing the Services.</p>

            <h4>3.5 Intellectual Property Rights</h4>
            <p>Shivam CloudSoft Solutions LLP reserves all of its intellectual property rights in the Services.
                Trademarks and logos used in connection with the Services are the trademarks of their respective owners.
                Shivam CloudSoft Solutions LLP, logo and other Shivam CloudSoft Solutions LLP trademarks, service
                marks, graphics and logos used for our Services are trademarks or registered trademarks of
                CloudDimension
                Technology Pvt Ltd.</p>

            <h3>4. Disclaimer and Limit of Liability</h3>
            <h4>4.1 No Warranty</h4>
            <p>Shivam CloudSoft Solutions LLP AND ITS AFFILIATES MAKE NO REPRESENTATION OR WARRANTY ABOUT THE
                SERVICES...</p>

            <h4>4.2 Exclusion of Liability</h4>
            <p>TO THE FULLEST EXTENT PERMITTED BY LAW...</p>

            <h3>5. Termination</h3>
            <p>Both you and Shivam CloudSoft Solutions LLP may terminate this Contract at any time...</p>

            <h3>6. Governing Law and Dispute Resolution</h3>
            <p>In the unlikely event we end up in a legal dispute...</p>

            <h3>7. General Terms</h3>
            <p>Here are some important details about the Contract...</p>

            <h3>8. Shivam CloudSoft Solutions LLP ("Dos and Don’ts")</h3>
            <h4>8.1 Dos</h4>
            <p>Shivam CloudSoft Solutions LLP is a community of professionals...</p>

            <h4>8.2 Don’ts</h4>
            <p>You agree that you will not...</p>

            <h3>9. Complaints Regarding Content</h3>
            <p>Contact information for complaint about content provided by our Members...</p>

            <h3>10. How To Contact Us</h3>
            <p>Our Contact information...</p>

            <h2>Cancellation & Refund Policy</h2>
            <h3>Cancellation Policy</h3>
            <p>Booking and Payments for services cannot be cancelled...</p>

            <h3>Refund Policy</h3>
            <p>Payments are non-refundable...</p>

        </div>
    </div>

    <!-- Modal Footer -->
    <div class="modal-footer terms-footer d-flex justify-content-end">
        <button type="button" class="btn btn-glass-cancel" data-bs-dismiss="modal" (click)="onAgree()">Close</button>
        <button type="button" class="btn btn-glass-agree" (click)="onAgree()">Agree</button>
    </div>
</div>